import type { JournalTemplate } from '../types/journal';

/** The Journal tab's template picker, the buttons that act on it, and its notes. */
export interface JournalTabElements {
  templateDropdown: HTMLSelectElement | null;
  insertBtn: HTMLButtonElement | null;
  validateBtn: HTMLButtonElement | null;
  pushBtn: HTMLButtonElement | null;
  postBtn: HTMLButtonElement | null;
  permissionNote: HTMLElement | null;
  emptyHint: HTMLElement | null;
}

const PLACEHOLDER = '<option value="">Select a template...</option>';

/** The tab of a company with Journal turned off: no template to pick and no button to send with. */
export function showJournalDisabled(el: JournalTabElements): void {
  if (el.templateDropdown) {
    el.templateDropdown.innerHTML = PLACEHOLDER;
    el.templateDropdown.disabled = true;
  }
  if (el.insertBtn) el.insertBtn.disabled = true;
  if (el.validateBtn) el.validateBtn.disabled = true;
  if (el.pushBtn) el.pushBtn.style.display = 'none';
  if (el.postBtn) el.postBtn.style.display = 'none';
  if (el.permissionNote) el.permissionNote.style.display = 'none';
  if (el.emptyHint) el.emptyHint.style.display = 'none';
}

/** The templates to pick from, or the hint for having none, with Insert and Check usable again. */
export function showJournalTemplates(el: JournalTabElements, templates: JournalTemplate[], emptyHint: string): void {
  if (el.templateDropdown) {
    el.templateDropdown.innerHTML = PLACEHOLDER;
    for (const t of templates) {
      const opt = document.createElement('option');
      opt.value = t.id;
      opt.textContent = t.displayName || t.name;
      el.templateDropdown.appendChild(opt);
    }
    el.templateDropdown.disabled = templates.length === 0;
  }
  if (el.insertBtn) el.insertBtn.disabled = false;
  if (el.validateBtn) el.validateBtn.disabled = false;
  if (el.emptyHint) {
    el.emptyHint.textContent = emptyHint;
    el.emptyHint.style.display = templates.length > 0 ? 'none' : 'block';
  }
}
